import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: '/new-car-deals/',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "new-car-deals" */ '../../new-car-deals/pages/new-car-deals-definition')
    ),
    enableLooseEtag: true,
  },
];
